// Designer.jsx
import DesignerList from "./DesignerList";

export default function Designer() {
  return <DesignerList type="designer" />;
}
